import type { AccRechargeRewardType } from '@/types/mall'

export const accRechargeReward: AccRechargeRewardType[] = [
  {
    level: 1,
    needCount: 10000,
    reward: {
      gold: 10000000,
    },
  },
  {
    level: 2,
    needCount: 30000,
    reward: {
      diamond: 3000,
      gold: 10000000,
    },
  },
  {
    level: 3,
    needCount: 50000,
    reward: {
      diamond: 5000,
      gold: 10000000,
    },
  },
  {
    level: 4,
    needCount: 100000,
    reward: {
      diamond: 5000,
      gold: 20000000,
      consumables: { runeStar: 20 },
    },
  },
  {
    level: 5,
    needCount: 200000,
    reward: {
      diamond: 5000,
      crystal: 10000,
      consumables: { runeStar: 30 },
    },
  },
  {
    level: 6,
    needCount: 300000,
    reward: {
      crystal: 20000,
      consumables: { runeStar: 50 },
    },
  },
  {
    level: 7,
    needCount: 500000,
    reward: {
      crystal: 20000,
      consumables: { shineBrightlyStone: 1 },
    },
  },
  {
    level: 8,
    needCount: 1000000,
    reward: {
      crystal: 50000,
      consumables: { shineBrightlyStone: 1 },
    },
  },
]
